import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import Home from "@/pages/Home";
import Stations from "@/pages/Stations";
import DailyOps from "@/pages/DailyOps";
import DailyOperationsSheet from "@/pages/DailyOperationsSheet";
import PnL from "@/pages/PnL";
import Staff from "@/pages/Staff";
import ChangePassword from "@/pages/ChangePassword";
import PriceHistory from "@/pages/PriceHistory";
import StockAlerts from "@/pages/StockAlerts";
import Budi from "@/pages/Budi";
import Summary from "@/pages/Summary";
import Kpdn from "@/pages/Kpdn";
import CreditCustomers from "@/pages/CreditCustomers";
import ShiftReconciliation from "@/pages/ShiftReconciliation";
import InstallPrompt from "@/components/InstallPrompt";
import { StationProvider } from "@/context/StationContext";

const wrap = (el, managerOnly = false) => (
  <ProtectedRoute managerOnly={managerOnly}>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="top-right" richColors />
      <InstallPrompt />
      <AuthProvider>
        <StationProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/" element={wrap(<Home />)} />
            <Route path="/operations" element={wrap(<DailyOps />)} />
            <Route path="/operations-sheet" element={wrap(<DailyOperationsSheet />)} />
            <Route path="/pnl" element={wrap(<PnL />)} />
            <Route path="/price-history" element={wrap(<PriceHistory />)} />
            <Route path="/stock" element={wrap(<StockAlerts />)} />
            <Route path="/budi" element={wrap(<Budi />)} />
            <Route path="/credit" element={wrap(<CreditCustomers />)} />
            <Route path="/shift-reconciliation" element={wrap(<ShiftReconciliation />)} />
            <Route path="/summary" element={wrap(<Summary />, true)} />
            <Route path="/kpdn" element={wrap(<Kpdn />, true)} />
            <Route path="/change-password" element={wrap(<ChangePassword />)} />
            <Route path="/stations" element={wrap(<Stations />, true)} />
            <Route path="/staff" element={wrap(<Staff />, true)} />
          </Routes>
        </BrowserRouter>
        </StationProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
